import { Button } from "@mui/material";
import "./invoiceData.scss";
import { withTranslation, useTranslation } from "react-i18next";
import { getLang } from "../../helper/getLang";
import user from "../../assets/images/User.svg"
import phone from "../../assets/images/Phone.svg"
import email from "../../assets/images/Email.svg"
const InvoiceData = (props: any) => {
  const { invoiceData, transaction, langValue } = props;
  const { t } = useTranslation();
  // console.log(props)

  return (
    <div className="invoice_details col-12">
      <div className="row m-0  justify-content-center">
        <h5 className="px-0 mt-4 familyPoppins600 headingSection">
          {t("Forms.Customer-info")}
        </h5>
        <div className="col-12 px-0">
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <span className="d-flex align-items-center">
                <img src={user} alt="user" />
              <h6 className=" mt-2 familysora400 mb-1 mx-2">Customer</h6>
              </span>
              <h6 className="familysora600 mt-2 ">{invoiceData?.customer?.name} </h6>
            </div>
          </div>
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <span className="d-flex align-items-center">
              <img src={phone} alt="user" />
              <h6 className=" mt-2 familysora400 mt-2 mb-1 mx-2">Phone</h6>
              </span>
              <h6 className="familysora600  ">{invoiceData?.customer?.number} </h6>
            </div>
          </div>
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <span className="d-flex align-items-center">
              <img src={email} alt="user" />
              <h6 className=" mt-2 familysora400 mb-1 mx-2">Mail</h6>
              </span>
              <h6 className="familysora600 mt-2 ">{invoiceData?.customer?.email} </h6>
            </div>
          </div>


        </div>
        <h5 className="px-0 mt-4 familyPoppins600 headingSection">
      {t("Forms.Booking-Details")}
        </h5>
        <div className="col-12 px-0">

          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">Booking Created By</h6>
              <h6 className="familysora600 mt-2 ">{transaction?.created_by} </h6>
            </div>
          </div>
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">No of Guests</h6>
              <h6 className="familysora600 mt-2 ">{invoiceData?.guests} </h6>
            </div>
          </div>
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">Booking Date</h6>
              <h6 className="familysora600 mt-2 ">{invoiceData?.booking_date} </h6>
            </div>
          </div>
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">Booking Time</h6>
              <h6 className="familysora600 mt-2 ">{transaction?.created_at} </h6>
            </div>
          </div>



        </div>
        <h5 className="px-0 mt-4 familyPoppins600 headingSection">
          {t("Forms.Order-Details")}
        </h5>
        <div className="col-12 px-0">
          <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">{t("Forms.Invoice-No")}</h6>
              <h6 className="familysora600 mt-2 "># {invoiceData?.id} </h6>
            </div>
          </div>
          {invoiceData && invoiceData?.created_at ? (
            <div className="col-12">
              <div className=" d-flex justify-content-between  px-1">
                <h6 className=" mt-2 familysora400">{t("Forms.Date")}</h6>
                <h6 className="familysora600 mt-2">{invoiceData?.created_at}</h6>
              </div>
            </div>
          ) : invoiceData?.failed_at?.date != null ? (
            <div className="col-12">
              <div className=" d-flex justify-content-between  px-1">
                <h6 className=" mt-2 familysora400">{t("Forms.Date")}</h6>
                <h6 className="familysora600 mt-2">
                  {" "}
                  {invoiceData?.failed_at?.date != null
                    ? invoiceData?.failed_at?.date
                    : ""}{" "}
                </h6>
              </div>
            </div>
          ) : (
            ''
          )}

          {/* {invoiceData? && invoiceData?.paid.time ? (
            <div className="col-12">
              <div className=" d-flex justify-content-between  px-1">
                <h6 className=" mt-2 familysora400">{t("Forms.Time")}</h6>
                <h6 className="familysora600 mt-2">{invoiceData?.paid.time}</h6>
              </div>
            </div>
          ) : invoiceData?.failed.time != null ? (
            <div className="col-12">
              <div className=" d-flex justify-content-between  px-1">
                <h6 className=" mt-2 familysora400">{t("Forms.Time")}</h6>
                <h6 className="familysora600">
                  {invoiceData?.failed.time != null
                    ? invoiceData?.failed.time
                    : ""}
                </h6>
              </div>
            </div>
          ) : (
            <div className="col-12">
              <div className=" d-flex justify-content-between  px-1">
                <h6 className=" mt-2 familysora400">{t("Forms.Time")}</h6>
                <h6 className="familysora600 mt-2">
                  {" "}
                  {invoiceData?.updated_at != null
                    ? invoiceData?.updated_at
                    : ""}{" "}
                </h6>
              </div>
            </div>
          )} */}

          {invoiceData?.transaction ? (
            invoiceData?.transaction.failed_at?.date ? (
              <div className="col-12">
                <div className=" d-flex justify-content-between  px-1">
                  <h6 className=" mt-2 familysora400">{t("Forms.Date")}</h6>
                  <h6 className="familysora600 mt-2">
                    {" "}
                    {invoiceData?.transaction.failed_at?.date}{" "}
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {invoiceData?.transaction ? (
            invoiceData?.transaction.failed_at?.time ? (
              <div className="col-12">
                <div className=" d-flex justify-content-between  px-1">
                  <h6 className=" mt-2 familysora400">{t("Forms.Time")}</h6>
                  <h6 className="familysora600 mt-2">
                    {" "}
                    {invoiceData?.transaction.failed_at?.time}
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {invoiceData?.status != "Pending" && <div className="col-12">
            <div className=" d-flex justify-content-between  px-1">
              <h6 className=" mt-2 familysora400">
                {t("Forms.Payment-Method")}
              </h6>
              <h6 className="familysora600 mt-2">
                {" "}
                {invoiceData?.status == "Direct"
                  ? "IN STORE"
                  : invoiceData?.status == "Partial"
                    ? "Split"
                    : invoiceData?.transaction
                      ? invoiceData?.transaction.payment_source
                      : ""}
              </h6>
            </div>
          </div>}


          {transaction?.tip > 0 && <div className="col-12"  >
            <div className=" d-flex justify-content-between  px-1 waiterTip" >
              <h6 className=" mt-2 familysora400">
                {t("Forms.Waiter-Tip")}

              </h6>
              <h6 className="familysora600 mt-2"  >
                {" "}
                {(transaction?.tip).toFixed(3)} KD
              </h6>
            </div>
          </div>}
          {invoiceData?.discount?.amount > 0 && <div className="col-12"  >
            <div className=" d-flex justify-content-between  px-1 " >
              <h6 className=" mt-2 familysora400">
                {t("Forms.discount-amount")}

              </h6>
              <h6 className="familysora600 mt-2"  >
                {" "}
                {(invoiceData?.discount?.amount).toFixed(3)} KD
              </h6>
            </div>
          </div>}

        </div>

        {invoiceData?.type !== "QuickInvoice" && (
          <h5 className="px-0 mt-4 familyPoppins600 headingSection">
            {t("Forms.Your-Order")}
          </h5>
        )}
        {invoiceData?.type !== "QuickInvoice" && (
          <div className="col-12 px-0 pb-5 mb-5">
            <ul className="px-0 mx-0">
              {invoiceData?.extras?.length > 0 &&
                invoiceData?.extras?.map((order: any, i: any) => {
                  // console.log("invoiceData?.extras",invoiceData.extras)
                  return (
                    <li key={i}>
                      <span className="text-secondary text-capitalize mt-2 d-flex align-item-center justify-content-between">
                        <span className="familysora400">
                          {" "}
                          {order.name
                            ? getLang(order.name, langValue)
                            : ""}{" "}
                        </span>
                        <span className="familysora600">
                          {" "}
                          {order.price ? order.price : ""} KD{" "}
                        </span>
                      </span>{order?.values?.map((addon: any, i: any) => {
                        if (typeof addon?.value === "string") {
                          return (
                            <span
                              key={i}
                              className="orderText d-flex align-item-center justify-content-between"
                            >
                              <span className="familysora400">
                                {addon
                                  ? addon?.name
                                    ? getLang(addon?.name, langValue)
                                    : ""
                                  : ""}
                              </span>
                              {addon && (
                                <span className="orderText familysora600">
                                  {" "}
                                  {addon?.value ? addon?.value : ""}
                                </span>
                              )}
                            </span>
                          );
                        } else {
                          return null; 
                        }
                      })}
                    </li>
                  );
                })}
            </ul>
          </div>
        )}

      </div>



    </div>
  );
};

export default InvoiceData;
